export const KEY = 'occupancy';

export const PARAM_KEY_FROM = 'occupancyFrom';
export const PARAM_KEY_TO = 'occupancyTo';

export const DEFAULT_FROM_OCCUPANCY = 0;
export const DEFAULT_TO_OCCUPANCY = 100;
